@use '~/theme/theme' as *;
@use '~/theme/typography';

.account {
  min-width: 180px;
}

.vatCode {
  min-width: 250px;
}

.purchaseTypeColumn {
  padding: 4px;
  max-width: 150px;
  min-width: 120px;

  & button > div {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    height: auto;
    margin-bottom: 0;
  }
}

.purchasePeriodColumn {
  max-width: 160px;
}

.fixedAssetColumn {
  width: 48px;
  text-align: center;
}

.adjustmentColumn {
  width: 48px;
  text-align: center;
}

.dateWrapper {
  padding: spacing(1);
  display: flex;
  align-items: center;
}

.dateInfo {
  display: flex;
  width: 100%;
}

.dateInput {
  &.unset {
    color: color(grey-600);
  }

  .dateSegment {
    &[data-focus-visible],
    &[data-focused] {
      outline: 2px solid color(violet-600);
      outline-offset: 1px;
      border-radius: 2px;
    }
  }
}
